/**
 * @desc: 支付通道
 * @created: 2020/6/1
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'
import qs from 'qs'

// 获取列表数据
export const getListData = params => {
  return request.get('/channel/channels', params)
}

// 根据ID获取通道详情信息
export const getChannelDetails = params => {
  return request.get('/channel/detail', params)
}

// 新增支付通道
export const confirmCreate = data => {
  return request.post('/channel/save', data, { json: true })
}

// 更新支付通道信息
export const confirmEditor = data => {
  return request.put('/channel/update', data, { json: true })
}

// 设置通道状态为启用或者停用
export const setChannelStatus = data => {
  return request.put('/channel/update/channel', qs.stringify(data))
}

// 根据银行渠道获取银行标识 
export const bankNameFindRepayPower = params => {
  return request.get('/factoring/bankNameFindRepayPower', params)
}

